export class Constants {
static readonly account: string = "vocus";
static readonly profile: string = "main";

static readonly page_id_activate_sim: string = "AF1";
static readonly page_id_mobile_plan: string = "AF2";
static readonly page_id_cart_about_you: string = "AF3";
static readonly page_id_cart_service_setup: string = "AF4";
static readonly page_id_cart_payment_details: string = "AF5";
static readonly page_id_cart_payment_summary: string = "AF6";
static readonly page_id_thank_you: string = "AF7";
static readonly page_id_error: string = "AF90";
static readonly page_id_checkout_error: string = "AF41";

static readonly fetch_included_channel_price: number = 5;
static readonly shipping_amount: string = "0";
static readonly tax_rate: number = 0.1;

static readonly category_broadband: string = "Broadband";
static readonly category_mobile: string = "Mobile";
static readonly category_energy: string = "Energy";
static readonly category_fetch: string = "Fetch";
static readonly category_voice: string = "Voice";

static readonly subcategory_adsl: string = "ADSL";
static readonly subcategory_nbn: string = "NBN";
static readonly subcategory_wireless: string = "Home Wireless";
static readonly subcategory_postpaid: string = "Mobile Postpaid";
static readonly subcategory_prepaid: string = "Mobile Prepaid";
static readonly subcategory_broadband: string = "Mobile Broadband";
static readonly subcategory_gas: string = "Gas";
static readonly subcategory_electricity: string = "Electricity";
static readonly subcategory_mighty: string = "Fetch Mighty";
static readonly subcategory_mini: string = "Fetch Mini";
static readonly subcategory_channel: string = "Fetch Channel";
static readonly subcategory_fixedline: string = "Fixed Line";
static readonly subcategory_voip: string = "VOIP";
static readonly subcategory_cpe: string = "CPE";
static readonly subcategory_mise: string = "MISC";
static readonly subcategory_addon: string = "Add-on";

static readonly product_brand_fetch: string = "Fetch";
static readonly product_id_landline: string = "LANDLINE";
static readonly product_name_landline: string = "Landline Rental";
static readonly product_id_new_number: string = "NEW-NUMBER";
static readonly product_name_new_number: string = "New phone number";
static readonly energy_allowance: string = "Actual";

static readonly page_name_active_phone_line = "Active Phone Line Found";
static readonly page_name_no_phone_line = "No Phone Line Found";

static readonly  session_storage_key = "cart-data";
}
